import { GET_WEAPON_RECIPES_SUCCESS } from "../actionTypes";

const initialState = []

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_WEAPON_RECIPES_SUCCESS: {
      const weaponRecipes = action.payload;

      if (!weaponRecipes){
        return {...state};
      }

      return [...state, ...action.payload]
    }

    default:
      return state;
  }
}
